import TeamsAnalyticsHome from '../../components/teams/TeamsAnalyticsHome';
import { compose, lifecycle, withState, withHandlers } from 'recompose';
import { connect } from 'react-redux';
import _ from 'lodash';
import { store } from 'store/createStore';

import { checkPermission } from 'utils/credentials';
import { ROLES } from '../../../../../consts';

import { fetchUsersInteraction } from '../../modules';
import API from '../../../../../utils/api';

const mapDispatchToProps = dispatch => ({
  fetchUsersInteraction(listUsersWithData, from, to, userAnonymous) {
    dispatch(fetchUsersInteraction(listUsersWithData, from, to, userAnonymous));
  },
});

const mapStateToProps = state => {
  return {
    roles: _.get(state, 'auth.currentGroup.myRoles', 'default'),
    listInteractions: _.get(state, 'analytics.listInteractions', []),
    listUsersInteraction: _.get(state, 'analytics.listUsersInteraction', []),
    showAnonymousUsers: _.get(state, 'analytics.showAnonymousUsers', true),
  };
};

const enhance = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withState('selectedTab', 'updateSelectedTab', 1),
  withState('leagueTop1', 'setLeagueTop', null),
  withState('leagueTop2', 'setLeagueTop2', null),
  withState('leagueTop3', 'setLeagueTop3', null),
  withState('favesSelected', 'setFavesSelected', 0),
  withState('teamsAnalyticsList', 'setTeamsAnalyticsList', []),
  withState('dateFrom', 'setDateFrom', null),
  withState('dateTo', 'setDateTo', null),
  withHandlers({
    onChangeTab: props => (evt, value) => {
      props.updateSelectedTab(value);
    },
    getTeamAnalytics: props => () => {
      const { currentGroup } = store.getState().auth;
      let query = {
        group: currentGroup._id,
      };
      if (props.dateFrom) {
        query.dateFrom = props.dateFrom;
      }
      if (props.dateTo) {
        query.dateTo = props.dateTo;
      }

      return API.getTeamAnalytics({
        ...query,
      }).then(teamAnalytics => {
        const data = _.get(teamAnalytics, 'data', []);
        const favesSelected = _.get(teamAnalytics, 'favesSelected', 0);

        props.setTeamsAnalyticsList(data);
        props.setFavesSelected(favesSelected);
        props.setLeagueTop(teamAnalytics.leagueTop1);
        props.setLeagueTop2(teamAnalytics.leagueTop2);
        props.setLeagueTop3(teamAnalytics.leagueTop3);
      });
    },
  }),
  lifecycle({
    async componentDidUpdate(prevProps) {
      checkPermission(this, ROLES.ANALYTICS);
    },
    componentDidMount() {
      this.props.getTeamAnalytics();
    },
  })
);

export default enhance(TeamsAnalyticsHome);
